<template>
  <mdb-col class="">
    <mdb-icon
      class="red-text pr-3"
      size="2x"
      icon="minus-square"
      @click.native="deleteNotification"
    />
    <p class="h6">{{ $t("advertisementnotification_due") + moment(localItem.due).format("DD.MM.YYYY hh:mm") }}</p>
    <p class="h6">{{ $t("advertisementnotification_title") + localItem.title }}</p>
    <p class="h6">{{ $t("advertisementnotification_radius") + localItem.radius }}</p>
    <p class="h6">{{ $t("advertisementnotification_unionmemberid") + unionmemberid }}</p>
  </mdb-col>
</template>
<script>
import { mdbCol, mdbIcon } from "mdbvue";
import moment from "moment";

export default {
  name: "AdvertisementNotifications",
  components: {
    mdbCol,
    mdbIcon,

  },
  props: {
    item: Object,
    index: Number
  },
  data() {
    return {
      localItem: this.item,
      localIndex: this.index
    };
  },
  methods: {
    deleteNotification() {
      this.$emit("notification-removed", this.localItem);
    }
  },
  computed: {
    moment() {
      return moment;
    },
    unionmemberid() {
      return this.localItem.unionmemberid == null?this.$t("advertisementnotification_unionmemberid_null"):this.localItem.unionmemberid;
    }
  }
};
</script>
<style>
.button-remove {
  width: 40px !important;
}
</style>
